import Modal from '@Components/Shared/Modals/Modal';
import Button from '@mui/material/Button';
import AutoBidIncrements from '@Components/Listings/AutoBidIncrements';

const AutoBidIncrementGroupModal = (props) => {
  
    const onClose = () => {
        props?.onClose?.() || props.setAutoBidIncrementData?.(null);
    };

    return (
        <Modal containerClassName='auto-bid-increment-group-modal' onEscapeKeyClose={onClose}>
            <Modal.Header onClose={onClose}>
                <Modal.Title>
                    {translator.translate('sandhills.bidincrementscale')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>                
                <AutoBidIncrements 
                    {...props}
                    CurrencyCode={props.CurrencyCode}
                    CultureCode={props.CultureCode}                    
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onClose}>{translator.translate('sandhills.closepage')}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AutoBidIncrementGroupModal;